import React from "react";

const Field = ({ label, name, value, onChange, readOnly }) => (
  <div className="col-md-4 mb-3">
    <label className="form-label">{label}</label>
    <input className="form-control form-control-sm" name={name} value={value || ""} onChange={onChange} readOnly={readOnly} />
  </div>
);

const Card = ({ title, children }) => (
  <div className="card mb-3">
    <div className="card-header bg-light"><h4 className="mb-0">{title}</h4></div>
    <div className="card-body"><div className="row">{children}</div></div>
  </div>
);

export function RetailerAccount({ jobData }) {
  const person = jobData?.general_details?.sales_person || {};
  const stored = Array.isArray(jobData?.retailer_details) ? jobData.retailer_details[0] || {} : {};
  const rows = [
    ["Retailer", jobData?.general_details?.retailer_name || person.retailer_name || stored.retailer_name],
    ["Contact", person.contact_name || jobData?.general_details?.employee_name],
    ["Email", person.retailer_email || person.email],
    ["Phone", person.phone_number],
    ["Booked by", person.employee_name || jobData?.general_details?.employee_name || "Account owner"],
  ];
  return (
    <div className="card mb-3">
      <div className="card-header bg-light"><h4 className="mb-0">Retailer Info</h4></div>
      <div className="card-body">
        <p className="text-muted small">This is the retailer account that created the booking.</p>
        <div className="row">
          {rows.map(([label, value]) => (
            <div className="col-md-4 mb-3" key={label}>
              <label className="form-label">{label}</label>
              <input className="form-control form-control-sm" value={value || "-"} readOnly />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function BookingParties({ jobData }) {
  const buyer = jobData?.buyer_details || {};
  const sender = jobData?.sender_details || {};
  const receiver = jobData?.receiver_details || {};
  const locked = { readOnly: true };

  return (
    <>
      <Card title="Buyer">
        <Field label="Type" value={buyer.customer_type} {...locked} />
        <Field label="Name" value={buyer.name} {...locked} />
        <Field label="Contact person" value={buyer.contact_person} {...locked} />
        <Field label="Email" value={buyer.email} {...locked} />
        <Field label="Phone" value={buyer.phone} {...locked} />
        <Field label="Address" value={buyer.address} {...locked} />
        <Field label="City" value={buyer.city} {...locked} />
        <Field label="Country" value={buyer.country} {...locked} />
        <Field label="Postal code" value={buyer.zip} {...locked} />
        <Field label="License" value={buyer.license_number} {...locked} />
        <Field label="Tax ID" value={buyer.tax_id} {...locked} />
      </Card>
      <Card title="Sender">
        <Field label="Type" value={sender.customer_type || sender.company_type} {...locked} />
        <Field label="Name" value={sender.full_name || sender.name} {...locked} />
        <Field label="Contact person" value={sender.contact_person} {...locked} />
        <Field label="Email" value={sender.email} {...locked} />
        <Field label="Phone" value={sender.phone_number || sender.phone} {...locked} />
        <Field label="Address" value={sender.address} {...locked} />
        <Field label="City" value={sender.city} {...locked} />
        <Field label="Country" value={sender.country} {...locked} />
        <Field label="Postal code" value={sender.zip} {...locked} />
        <Field label="License" value={sender.license_number} {...locked} />
        <Field label="Tax ID" value={sender.tax_id || sender.trn} {...locked} />
      </Card>
      <Card title="Receiver">
        <Field label="Type" value={receiver.customer_type || receiver.company_type} {...locked} />
        <Field label="Name" value={receiver.receiver_name} {...locked} />
        <Field label="Contact person" value={receiver.contact_person} {...locked} />
        <Field label="Email" value={receiver.email} {...locked} />
        <Field label="Phone" value={receiver.pickup_contact} {...locked} />
        <Field label="Address" value={receiver.address} {...locked} />
        <Field label="City" value={receiver.city} {...locked} />
        <Field label="Country" value={receiver.country} {...locked} />
        <Field label="Postal code" value={receiver.postal_code} {...locked} />
        <Field label="License" value={receiver.license_number} {...locked} />
        <Field label="Tax ID" value={receiver.tax_id} {...locked} />
      </Card>
    </>
  );
}
